import './vendors';
import './style/drag_and_drop.scss';
import './main';



// WEBPACK FOOTER //
// ./src/app/dragdropway/index.js